import { render, staticRenderFns } from "./compositionRow.vue?vue&type=template&id=54aa8fe2&scoped=true"
import script from "./compositionRow.vue?vue&type=script&lang=js"
export * from "./compositionRow.vue?vue&type=script&lang=js"
import style0 from "./compositionRow.vue?vue&type=style&index=0&id=54aa8fe2&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa8fe2",
  null
  
)

export default component.exports